'use strict';

exports.__esModule = true;
exports.merge = merge;

var _TagTypes = require('../types/TagTypes');

var _identify = require('./utils/identify');

var SCRIPT = _TagTypes.TAG_TYPES.SCRIPT;

var nonUniqueIdentifiers = [SCRIPT];

function merge(a, b) {
  var tags = [];
  var uniqueTagCache = {};

  var safeA = Array.isArray(a) ? a : [];
  var safeB = Array.isArray(b) ? b : [];

  var merged = [].concat(safeB.some(function (tag) {
    return tag.custom;
  }) ? safeA.filter(function (tag) {
    return !tag.custom;
  }) : safeA).concat(safeB);

  for (var i = merged.length - 1; i >= 0; i--) {
    var identifier = (0, _identify.identify)(merged[i]);
    if (identifier && !nonUniqueIdentifiers.includes(identifier)) {
      if (!uniqueTagCache[identifier]) {
        tags.push(merged[i]);
        uniqueTagCache[identifier] = true;
      }
    } else {
      tags.push(merged[i]);
    }
  }

  return tags;
}